import React from 'react';
import SEO from '../components/common/SEO';
import Layout from '../components/layout/Layout';
import Section from '../components/common/Section';
import Features from '../components/home/Features';
import HowItWorks from '../components/home/HowItWorks';
import CTA from '../components/home/CTA';
import { siteConfig } from '../config/site';

const FeaturesPage: React.FC = () => (
  <Layout>
    <SEO
      title={`Features | ${siteConfig.brand.name}`}
      description={`Explore every feature of ${siteConfig.brand.name} — 365-day validity, P2P support, cross-chain USDT flashing, and more.`}
      keywords="flash USDT features, USDT flashing capabilities, USDT TRC20 flashing features"
    />
    <Section
      title="Features"
      subtitle={`Everything ${siteConfig.brand.name} brings to your USDT flashing workflow.`}
      background="light"
      padding="large"
      isMainTitle={true}
    >
      <div />
    </Section>
    <Features />
    <HowItWorks />
    <CTA />
  </Layout>
);

export default FeaturesPage;
